import { SagaMiddleware } from "redux-saga";

import authSaga from "./sagas";

export default function configureAuth(sagaMiddleware: SagaMiddleware) {
  sagaMiddleware.run(authSaga);
}
